import SparkMD5 from "spark-md5";

export const md5 = {
    buffer_hash: SparkMD5.ArrayBuffer.hash,
    hash: SparkMD5.hash,
    state: SparkMD5
};
